'use strict';
import angular from 'angular';
import modalDialogHtmlUrl from '../../views/directives/modalDialog.html';

angular.module('formFields.directives', [])
	.directive('modalDialog', function() {
		return {
			restrict: 'E',
			scope: {
				show: '=',
				workflowObj: '=',
				cellObj: '=',
				workflowData: '='
			},
			transclude: true, // Insert custom content inside the directive
			link: function(scope, element, attrs) {	
			},
			templateUrl: modalDialogHtmlUrl
		};
	});
	